import { html as beautify } from 'js-beautify'
import CodeEditor from './CodeEditor'
import React, { Component } from 'react'

if (process.env.BROWSER) require('../../styles/Editor.less')

class Editor extends Component {

  static defaultProps = {
    height: '100%',
    value: ''
  }

  constructor (props) {
    super()

    this.lastValue = props.value
  }

  shouldComponentUpdate (nextProps) {
    return this.lastValue.trim() !== nextProps.value.trim() ||
    this.props.errors !== nextProps.errors ||
    this.props.height !== nextProps.height ||
    this.props.uiSize !== nextProps.uiSize
  }

  componentDidMount () {
    this.editor.getScrollerElement().addEventListener('scroll', e => {
      const el = e.currentTarget
      const totalScroll = el.scrollHeight - el.clientHeight
      this.props.onScroll(el.scrollTop / totalScroll * 100)
    })
  }

  handleBeautify = () => {
    let value = this.getValue()

    if (value !== '') {
      value = beautify(value, {
        indent_size: 2,
        wrap_attributes_indent_size: 2,
        max_preserve_newlines: 1,
        extra_liners: ['mj-accordion', 'mj-button', 'mj-carousel', 'mj-divider', 'mj-image', 'mj-navbar', 'mj-raw', 'mj-social', 'mj-spacer', 'mj-table', 'mj-text', '/mj-column', '/mj-hero']
      })

      this.editor.setValue(value)

      this.debounceOnChange(value)
    }
  }

  getValue () {
    return this.editor.getValue()
  }

  debounceOnChange = _.debounce(mjml => {
    this.lastValue = mjml

    this.props.onChange(this.lastValue)
  }, 150)

  render () {
    const { elements, height, errors } = this.props
    return (
      <div className="Editor">
        <div className="Editor-Header">
          <div className="Editor-Toolbar">
            <div className="Editor-Buttons">
              <button
                className="Button is-ghost"
                onClick={this.handleBeautify.bind(this)}>
                Beautify MJML
              </button>
            </div>
          </div>
        </div>
        <CodeEditor
          elements={elements}
          errors={errors}
          height={height}
          mode="xml"
          name="mjmlEditor"
          onChange={editor => this.debounceOnChange(editor.getValue())}
          ref={r => this.editor = r && r._codeMirror }
          value={this.lastValue} />
      </div>
    )
  }

}

export default Editor
